import { render } from "./notificationModal.vue?vue&type=template&id=43336126&scoped=true"
import script from "./notificationModal.vue?vue&type=script&lang=js"
export * from "./notificationModal.vue?vue&type=script&lang=js"

import "./notificationModal.vue?vue&type=style&index=0&id=43336126&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43336126"]])

export default __exports__